import { type MutableRefObject, useEffect, useState } from 'react'
import { assumeExhaustion } from '../../../shared/lib/typeHelpers.no-deps'

export type BreakpointDefinition =
    | {
          type: 'limit'
          size: number
          condition: '<' | '>'
          className: string
      }
    | {
          type: 'range'
          min: number
          max: number
          className: string
      }

const useBreakpoints = (ref: MutableRefObject<HTMLDivElement>, breakpoints: BreakpointDefinition[]) => {
    const [classes, setClasses] = useState<string[]>([])

    useEffect(() => {
        const handleResize = () => {
            const elementWidth = ref.current.scrollWidth

            const classesToApply = breakpoints
                .filter((breakpoint) => {
                    if (breakpoint.type === 'limit') {
                        return breakpoint.condition === '<'
                            ? elementWidth < breakpoint.size
                            : elementWidth > breakpoint.size
                    }

                    if (breakpoint.type === 'range') {
                        return elementWidth < breakpoint.max && elementWidth > breakpoint.min
                    }

                    assumeExhaustion(breakpoint)
                })
                .map(({ className }) => className)

            setClasses(classesToApply)
        }

        handleResize()

        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [breakpoints])

    return classes
}

export default useBreakpoints
